export default __webpack_public_path__ + "static/media/service2.01059200.png";